// extracted by mini-css-extract-plugin
export var menuIcon = "_tf-0";
export var menuIconInline = "_tf-1";